/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentValidationRequestDataModel {
    getFixupPrototypeFunction() { return AssessmentValidationRequestDataModel.fixupPrototype; }

    static newInstance(model: Partial<AssessmentValidationRequestDataModel>): AssessmentValidationRequestDataModel {
        let obj = Object.assign(new AssessmentValidationRequestDataModel(), model);
        AssessmentValidationRequestDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentValidationRequestDataModel>): AssessmentValidationRequestDataModel {
        if (!model) return null;
        return AssessmentValidationRequestDataModel.newInstance(<AssessmentValidationRequestDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentValidationRequestDataModel) {
        if (!obj) return;

        models.AssessmentValidationRequestDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentValidationRequestDataModel): boolean {
        Object.setPrototypeOf(obj, AssessmentValidationRequestDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of validation for the cloud account. If post_onboarding is selected, then the category can only be cost/access/resource/operations/security. Post Onboarding applies for Governance Configuration
     */
    validation_type: models.ValidationType;

    /**
     * Category of assessment validation for the cloud account
     */
    category: models.AssessmentCategory;

}
